import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { PAGE_PREBID_STACK_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const UPDATE_PAGE_PREBID_STACK: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${PAGE_PREBID_STACK_FRAGMENT}
  ${ERROR_FRAGMENT}

  mutation updatePagePrebidStack($input: UpdatePagePrebidStackInput!) {
    updatePagePrebidStack(input: $input) {
      pagePrebidStack {
        ...PagePrebidStackFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
